const configs={
    "localhost": {
        API_URL:"https://fur-dev-api.vedasoftinc.click/furservice"
    },
    "fur-dev.vedasoftinc.click": {
        API_URL:"https://fur-dev-api.vedasoftinc.click/furservice"
    },    
    "fur-dev.nmgcloudapps.com":{
        API_URL:"https://dev-api.nmgcloudapps.com/furservice"
    },    
    "fur-dev-int.nmgcloudapps.com": {
        API_URL: "https://dev-int-api.nmgcloudapps.com/furservice"
    },    
    "fur-preprod.neimanmarcus.com": {
        API_URL: "/furservice"
    },    
    "fur.neimanmarcus.com": {
        API_URL: "/furservice"
    }
}
module.exports.getApiDomain = () => {
    return configs[window.location.hostname].API_URL
};